import { useMemo } from 'react';

import { definitions } from '@luxuryescapes/contract-svc-promo';

import { toPromoBrand } from '~/consts/promoBrand';

import { useAppSelector } from './store';

type CurrentPromoBrand = {
  brand: string;
  promoBrand: definitions['Promo Brands'];
};

export default function useCurrentPromoBrand(): CurrentPromoBrand {
  const brand = useAppSelector((state) => state.tenant.brand);
  let promoBrand = toPromoBrand(brand);
  if (!promoBrand) {
    console.warn(
      `useCurrentPromoBrand: tenant brand "${brand}" is not a valid promo brand, defaulting to luxuryescapes`,
    );
    promoBrand = 'luxuryescapes';
  }
  return useMemo(() => ({ brand, promoBrand }), [brand, promoBrand]);
}
